exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-slider-v2 .react-colorful{width:100%;height:100%}.cap-slider-v2 .react-colorful__saturation{display:none}.cap-slider-v2 .react-colorful__last-control{border-radius:2px}\n", ""]);

// exports
